// Logo WÔMA de ARTEKNOS — composant réutilisable, palette Luxury
// Image circulaire dorée hébergée en /public/woma-logo.png
// Usage: <ArteknosLogo size="sm|md|lg|xl" showText={true} textColor="text-white" />
import React from "react";

const WOMA_LOGO_URL = "/woma-logo.png";

const SIZE_CLASSES = {
  xs: "w-8 h-8",
  sm: "w-10 h-10",
  md: "w-12 h-12",
  lg: "w-16 h-16",
  xl: "w-20 h-20",
  "2xl": "w-24 h-24",
};

export default function ArteknosLogo({
  size = "md",
  showText = false,
  textColor = "text-white",
  textSize = "text-base",
  className = "",
  "data-testid": dataTestId,
}) {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={dataTestId || "woma-logo"}>
      <div
        className={`${sizeClass} rounded-full overflow-hidden ring-2 ring-[#D4AF37]/50 shadow-[0_0_18px_rgba(212,175,55,0.35)] bg-black flex-shrink-0`}
      >
        <img
          src={WOMA_LOGO_URL}
          alt="WÔMA de ARTEKNOS"
          className="w-full h-full object-cover"
          loading="eager"
          draggable={false}
        />
      </div>
      {showText && (
        <span
          className={`font-black uppercase tracking-tight ${textColor} ${textSize} leading-none`}
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          WÔMA <span className="text-[#D4AF37]">de ARTEKNOS</span>
        </span>
      )}
    </div>
  );
}

export { WOMA_LOGO_URL as ARTEKNOS_LOGO_URL, WOMA_LOGO_URL };
